import { createSlice } from '@reduxjs/toolkit';
import { post } from 'api/fetch';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/purchaseInsurance/independencePayment/cardholderVerification',
  initialState: {
    isLoading: false,
    error: null,
    isVerificationCompleted: false,
    isCardholderValid: false
  },
  reducers: {
    // verifyCardholder
    verifyCardholderRequest: (state) => {
      state.isLoading = true;
      state.error = null;
      state.isVerificationCompleted = false;
      state.isCardholderValid = false;
    },
    verifyCardholderSuccess: (state, { payload: isCardholderValid }) => {
      state.isLoading = false;
      state.error = null;
      state.isVerificationCompleted = true;
      state.isCardholderValid = isCardholderValid;
    },
    verifyCardholderFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.isVerificationCompleted = true;
      state.isCardholderValid = false;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const verifyCardholder = (fullName, dateOfBirth) => async (dispatch) => {
  dispatch(actions.verifyCardholderRequest());
  try {
    const { isVerified: isCardholderValid } = await post(
      '/verification/v1/compare-full-name-and-verify',
      {
        fullName,
        dateOfBirth
      },
      {
        isNIOrchestrator: true
      }
    );

    dispatch(actions.verifyCardholderSuccess(isCardholderValid));
  } catch (error) {
    dispatch(actions.verifyCardholderFailure(error));
  }
};
